// Slider technologií: šipky, tečky i swipe po obrázku přepínají celou
// technologii (text + fotku)
export default class TechSlider {
    static init(): void {
        const sliders: NodeListOf<HTMLElement> = document.querySelectorAll('[data-tech-slider]');

        sliders.forEach((slider) => this.sliderInit(slider));
    }

    static sliderInit(slider: HTMLElement): void {
        const texts: HTMLElement[] = Array.from(slider.querySelectorAll('[data-tech-text]'));
        const images: HTMLElement[] = Array.from(slider.querySelectorAll('[data-tech-image]'));
        const dots: HTMLElement[] = Array.from(slider.querySelectorAll('[data-tech-dot]'));

        if (texts.length === 0) {
            return;
        }

        let current = 0;

        const setActive = (index: number): void => {
            current = (index + texts.length) % texts.length;

            texts.forEach((text, i) => text.classList.toggle('tech-slider__text--active', i === current));
            images.forEach((image, i) => image.classList.toggle('tech-slider__image--active', i === current));
            dots.forEach((dot, i) => dot.classList.toggle('tech-slider__dot--active', i === current));
        };

        slider.querySelector('[data-tech-prev]')?.addEventListener('click', () => setActive(current - 1));
        slider.querySelector('[data-tech-next]')?.addEventListener('click', () => setActive(current + 1));

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => setActive(index));
        });

        this.bindSwipe(slider, (direction) => setActive(current + direction));
    }

    static bindSwipe(slider: HTMLElement, onSwipe: (direction: number) => void): void {
        const stage: HTMLElement | null = slider.querySelector('[data-tech-stage]');
        const THRESHOLD = 40;
        let startX = 0;
        let startY = 0;

        if (!stage) {
            return;
        }

        stage.addEventListener(
            'touchstart',
            (event: TouchEvent) => {
                startX = event.touches[0].clientX;
                startY = event.touches[0].clientY;
            },
            { passive: true },
        );

        stage.addEventListener('touchend', (event: TouchEvent) => {
            const deltaX = event.changedTouches[0].clientX - startX;
            const deltaY = event.changedTouches[0].clientY - startY;

            if (Math.abs(deltaX) > THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
                onSwipe(deltaX < 0 ? 1 : -1);
            }
        });
    }
}
